module.exports = __webpack_public_path__ + "img/cost.348d8ff1.png";